<template>
  <span>
    <EmojiIcon
      v-if="iconType === emojiEnum"
      :emoji="iconName"
      :classes="'ml-auto mr-auto flex items-center justify-center'"
    />
    <em
      v-else
      :style="getFilterValueIconStyle"
      class="custom-icons flex"
      :class="iconClass"
    />
  </span>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import EmojiIcon from '@/components/functional/EmojiIcon.vue';

export default {
  name: 'FilterValueIcon',

  components: {
    EmojiIcon,
  },

  mixins: [customIconsMixin],

  props: {
    icon: {
      type: String,
      required: false,
      default: '',
    },

    type: {
      type: String,
      required: false,
      default: '',
    },

    color: {
      type: String,
      required: false,
      default: '#667085',
    },

    iconName: {
      type: String,
      required: false,
      default: '',
    },

    isNoAssignees: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconType: {
      type: String,
      required: false,
      default: '',
    },
    iconClass: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    getFilterValueIconStyle() {
      if (this.type === 'tags') {
        if (Object.keys(this.$store.getters.getTags).includes(this.icon)) {
          const tag = this.$store.getters.getTags[this.icon];
          const { color } = tag;
          return {
            ...this.getCustomIconStyle(this.iconPath(this.iconName)),
            background: color,
          };
        }
      }
      if (this.type === 'external_links') {
        let icon = this.iconName;
        if (this.icon === 'github_pull_request') {
          icon = 'github-icon';
        }

        return {
          ...this.getCustomIconStyle(this.iconPath(icon)),
          background: this.color,
        };
      }
      return this.iconStyle;
    },

    iconStyle() {
      let filterValueIconName = this.iconName;
      if (this.isNoAssignees) {
        filterValueIconName = 'user';
      }
      return {
        ...this.getCustomIconStyle(this.iconPath(filterValueIconName)),
        background: this.color,
      };
    },
  },
};
</script>
